import React, { useContext, useReducer, useEffect, useMemo } from 'react'
import ColorButton from '../../Buttons/ColorButton'
import { Box, TextField, Typography } from '@mui/material';
import { lockedReducer } from '../../Utils/reducers';
import RenameModal from './renameModal';
import { externalComponent } from '../../AppRoutes';

const SettingsConsultas = () => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        renameModal: null
    })

    const { setLoader } = useContext(externalComponent)

    return (
        <>

            {
                state.renameModal &&
                <RenameModal
                    data={state.renameModal}
                    handleClose={() => setState({ renameModal: null })}
                    setLoader={setLoader}
                />
            }

            <Box sx={{ display: 'flex', flexDirection: 'column', width: '70%' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                    <Typography>Renomeia o nome da empresa que será apresentado na coluna da tabela de consulta de estoque:</Typography>
                    <ColorButton onClick={() => setState({ renameModal: true })}>Renomear empresa</ColorButton>
                </Box>
            </Box>
        </>
    )
}

export default SettingsConsultas